module.exports = __webpack_public_path__ + "img/prestogo_login.abba95c0.png";